import { addCommas } from "@persian-tools/persian-tools";
import Drawer from "../../../components/drawer/Drawer";
import CustomButton from "../../kits/custom-button/CustomButton";
import ColorSchema from "../../../assets/kits/colors";

export default function OrderDetailDrawer({ isOpen, setIsOpen, height = 135 }) {
  return (
    <>
      <Drawer isOpen={isOpen} onClose={() => setIsOpen(false)} height={height}>
        <div style={{ color: ColorSchema.gray_900 }}>
          {" "}
          <h5 className="mr-t-16 title-h3-b pd-r-16">جزئیات سفارش</h5>
          <div className="mr-t-16 ">
            <ProductItem count="4" title="چیپس نمکی" price="26000" />
            <div
              className="mr-x-16 mr-y-12"
              style={{
                borderTop: `1px solid ${ColorSchema.gray_600}`,
                opacity: 0.3,
              }}
            ></div>
            <ProductItem count="2" title="پفک چی توز" price="81000" />
            <div
              className="mr-x-16 mr-y-12"
              style={{
                borderTop: `1px solid ${ColorSchema.gray_600}`,
                opacity: 0.3,
              }}
            ></div>
            <ProductItem count="1" title="بستنی فالوده ای" price="12000" />
          </div>
          <div className="mr-t-16 d-flex pd-x-16">
            <div className="mr-l-16 flex-grow-1">
              {" "}
              <CustomButton
                className="pd-x-16 w-50 w-100 "
                buttonStyle="text"
                state="default"
                size="large"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <span className="title-h4-m">نیاز به پشتیبانی </span>
              </CustomButton>
            </div>
            <div className="flex-grow-1">
              {" "}
              <CustomButton
                className="pd-x-16 w-50 w-100"
                buttonStyle="primary"
                state="default"
                size="large"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <span className="title-h4-m">قبول کردن</span>
              </CustomButton>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}
const ProductItem = ({ count, title, price }) => {
  return (
    <div className="d-flex justify-content-between title-h5-m pd-x-20">
      <div className="d-flex">
        {" "}
        <div className="mr-l-8">x{count}</div>
        <div>{title}</div>
      </div>

      <div className="desc-m">
        {addCommas(price)}
        <span className="mr-r-4">تومان</span>
      </div>
    </div>
  );
};
